// src/pages/FilterInspiration.js 
// (Assuming this file contains your FilterInspiration component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
// NotificationBar was in the original useMeta import block but not in the return JSX, 
// and was also not present in the original return for this specific component.

// Page Component
import FIcontent from './PageComponent/FIcontent';

function FilterInspiration() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Filter Inspiration | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover new inspiration for your lifestyle. Explore creative ideas to refresh your routine. Start your journey today!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/filter-inspiration/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Filter Inspiration" />
                <meta
                    property="og:description"
                    content="Discover new inspiration for your lifestyle. Explore creative ideas to refresh your routine. Start your journey today!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/filter-inspiration/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <FIcontent />
                <Footer />
            </div>
        </>
    );
}

export default FilterInspiration;